import type { Model, Option } from '@/types'

export function calculateTotal(
  selectedModelId: number | null,
  selectedOptionIds: number[],
  models: Model[],
  options: Option[]
): number {
  const model = models.find((m) => m.id === selectedModelId)
  if (!model) return 0
  const optionTotal = options
    .filter((o) => selectedOptionIds.includes(o.id))
    .reduce((sum, o) => sum + o.price, 0)
  return model.base_price + optionTotal
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(amount)
}
